import { SecurityQuestion } from './security-question';

export class SecurityQuestionReset {
    email = '';
    password = '';
    securityQuestions: SecurityQuestion[] = [];
}
